<template lang="pug">
y-dialog(
  v-model="showDialog"
  max-width="500"
  persistent
)
  v-card
    v-card-title.h6.basic800--text Approve Payment 
    v-divider.basic300
    v-card-text
      v-form(ref="form")
        // Payment Amount
        v-text-field(
          v-model="paymentAmount"
          :label="$t('payment_amount')"
          type="number"
          :rules="[...rules.not_empty, ...rules.payment_amount]"
          dense
        )

        // Payment Date
        v-menu(
          v-model="showDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        )
          template(v-slot:activator="{ on, attrs }")
            v-text-field(
              v-model="paymentDate"
              :label="$t('payment_date')"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="rules.not_empty"
              dense
            )
          v-date-picker(
            v-model="paymentDate"
            @input="showDatePicker = false"
          )

    v-card-actions
      v-spacer
      v-btn(color='white', text @click='showDialog = false')
        .button-Aa-small.primary400--text {{ $t('cancel') }}
      v-btn.mr-2(
        color='textColorAccent'
        depressed
        height=32
        @click='submitPayment'
        :loading="isSubmitting"
        dark
      )
        .button-AA-small.basic100--text {{ $t('submit') }}
</template>

<script>
export default {
  name: 'ApprovePaymentDialog',
  props: {
    lead: {
    type: Object,
    required: true
     },
    open: {
      type: Boolean,
      default: false
    },
    invoiceData: {
      type: Object,
      default: () => ({})
    },
    leadId: {
      type: String,
      required: true
    },
    leadPid: {
      type: String,
      required: true
    },
    leadPhone: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showDialog: this.open,
      paymentAmount: null,
      paymentDate: new Date().toISOString().substr(0, 10), // Default to today's date
      showDatePicker: false,
      isSubmitting: false,
      rules: {
        not_empty: [val => (val || '').toString().length > 0 || 'This field is required'],
        payment_amount: [
        val => (val || '').toString().length > 0 || 'This field is required',
        val => {
          //onst discount = this.invoiceData.discounts.reduce((sum, discount) => sum + Number(discount.amount), 0)
          const currentBalance = this.invoiceData.balance_payment || (this.invoiceData.total.amount * 1.08);
          return Number(val) <= currentBalance || `Payment cannot exceed ${currentBalance}`;
        }
      ]
      }
    };
  },
  watch: {
    open(newValue) {
      this.showDialog = newValue;
    },
    showDialog(newValue) {
      if (!newValue) {
        this.$emit('update:open', false);
      }
    }
  },
  methods: {
    async submitPayment() {
        if (!this.$refs.form.validate()) return;
        this.isSubmitting = true;

        try {
        //const discount = this.invoiceData.discounts.reduce((sum, discount) => sum + Number(discount.amount), 0)
        const currentBalancePayment = this.invoiceData.balance_payment || (this.invoiceData.total.amount * 1.08);
        const newBalancePayment = currentBalancePayment - this.paymentAmount;
        const newStatus = newBalancePayment === 0 ? 'shipped' : 'partial_payment';

        const updatedInvoiceData = {
            ...this.invoiceData,
            balance_payment: newBalancePayment
        };

        const extra_fields_data = Array.isArray(this.lead?.extra_fields_data) 
            ? [...this.lead.extra_fields_data] 
            : [];

        const invoiceField = {
            type: 'text',
            name: 'Invoice',
            enabled: true,
            value: JSON.stringify(updatedInvoiceData)
        };

        const existingIndex = extra_fields_data.findIndex(f => f.name === 'Invoice');
        if (existingIndex >= 0) {
            extra_fields_data[existingIndex] = invoiceField;
        } else {
            extra_fields_data.push(invoiceField);
        }

        const updateResponse = await this.$axios.patch(`/leads/${this.lead.pid}/`, {
            status: newStatus,
            extra_fields_data
        });

        if (updateResponse.status === 200) {
            await this.$axios.post('https://flow.yezza.com/webhook/89c827f9-9006-44eb-bb7a-9a3ffce988c0', {
            paymentAmount: this.paymentAmount,
            paymentDate: this.paymentDate,
            invoiceData: updatedInvoiceData,
            lead_id: this.leadId,
            lead_pid: this.leadPid,
            lead_phone: this.leadPhone
            });

            this.$emit('payment-approved', updateResponse.data);
            this.showDialog = false;
            this.showMessage(['success', 'Payment approved and lead status updated']);
            window.location.reload();
        }

        } catch (error) {
        console.error('Error:', error);
        this.showMessage(['error', error.message || 'Unable to process payment']);
        } finally {
        this.isSubmitting = false;
        }
        }
  }
};
</script>

<i18n>
{
  "en": {
    "payment_amount": "Payment Amount",
    "payment_date": "Payment Date",
    "cancel": "Cancel",
    "submit": "Submit"
  }
}
</i18n>